export class ManPowerReqDetailExpertiseDto {
  /** Can be null when sending to API. API will figure our the ID from ManPowerReqDetailId and ExpertiseId */
  ManPowerReqDetailExpertiseId: string | null;
  /** Can be null when sending to API if the dto is part of parent SaveUpdateManPowerReqDetailDTO where API can figure our the ManPowerReqDetailId from parent object. */
  ManPowerReqDetailId: string | null;
  ExpertiseId: string;
  Rating: number | null;
  IsActive: boolean | null;
}
